/*
 * Copyright '2025' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export class ExtendedClaims {
  public static readonly USER_STATUS = "userStatus";
  public static readonly AUTHENTICATED_AS_IMPERSONATOR =
    "authenticatedAsImpersonator";
  public static readonly TOU_ACTION = "touAction";
  public static readonly SETUP_COMPLETE = "setupComplete";
}

export class UserClaimsKey {
  public static readonly USER_IDENTIFIER = "email";
  public static readonly PRINCIPAL_NAME = "email";
  public static readonly DISPLAY_NAME = "displayName";
  public static readonly USER_STATUS = "userStatus";
  public static readonly AUTHENTICATED_AS_IMPERSONATOR =
    "authenticatedAsImpersonator";
  public static readonly TOU_ACTION = "touAction";
  public static readonly SETUP_COMPLETE = "setupComplete";
}
